import { render, staticRenderFns } from "./Legislation.vue?vue&type=template&id=8f0a231c&scoped=true"
import script from "./Legislation.vue?vue&type=script&lang=js"
export * from "./Legislation.vue?vue&type=script&lang=js"
import style0 from "./Legislation.vue?vue&type=style&index=0&id=8f0a231c&prod&scoped=true&lang=css"
import style1 from "./Legislation.vue?vue&type=style&index=1&id=8f0a231c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0a231c",
  null
  
)

export default component.exports